import { useId, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../app/universalComponents/Header";
import Footer from "../../app/universalComponents/Footer";
import { useAuth } from "../../app/auth/AuthProvider";

export default function LoginPage() {
    const location = useLocation();
    const from = location.state?.from?.pathname || "/dashboard";

    const emailId = useId();
    const passwordId = useId();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");

    const navigate = useNavigate();
    const { signIn } = useAuth();

    async function handleSubmit(e) {
        e.preventDefault();

        setError("");
        setIsSubmitting(true);

        try {
            await signIn(email, password);
            navigate(from, { replace: true });
        } catch (err) {
            setError("Invalid email or password.");
            setPassword("");
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div className="min-h-screen flex flex-col bg-white">
            <Header />

            <main className="flex flex-1 items-center justify-center px-6 py-12">
                <section className="w-full max-w-md rounded-sm border border-gray-300 bg-white p-6 shadow-sm">
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                            Organiser access
                        </p>

                        <h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900">
                            Sign in
                        </h1>

                        <p className="mt-2 text-sm text-gray-600">
                            Use your Tickets.NP account to manage your events,
                            tickets, and orders.
                        </p>
                    </div>

                    {error && (
                        <div
                            role="alert"
                            className="mt-6 rounded-sm border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700"
                        >
                            {error}
                        </div>
                    )}

                    <form
                        onSubmit={handleSubmit}
                        noValidate
                        className="mt-6 space-y-4"
                    >
                        <div>
                            <label
                                htmlFor={emailId}
                                className="text-xs font-semibold uppercase tracking-widest text-gray-500"
                            >
                                Email
                            </label>

                            <input
                                id={emailId}
                                name="email"
                                type="email"
                                inputMode="email"
                                autoComplete="email"
                                required
                                value={email}
                                placeholder="you@example.com"
                                onChange={(e) => setEmail(e.target.value)}
                                className="mt-2 w-full rounded-sm border border-gray-300 bg-white px-3 py-2 text-base text-gray-900 outline-none transition focus:border-black focus:ring-2 focus:ring-black/10"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor={passwordId}
                                className="text-xs font-semibold uppercase tracking-widest text-gray-500"
                            >
                                Password
                            </label>

                            <input
                                id={passwordId}
                                name="password"
                                type="password"
                                autoComplete="current-password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="mt-2 w-full rounded-sm border border-gray-300 bg-white px-3 py-2 text-base text-gray-900 outline-none transition focus:border-black focus:ring-2 focus:ring-black/10"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="w-full rounded-sm bg-black px-4 py-2 text-base font-semibold text-white transition hover:opacity-75 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {isSubmitting ? "Signing in..." : "Sign in"}
                        </button>
                    </form>
                </section>
            </main>

            <Footer />
        </div>
    );
}